var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowNext = function SvgArrowNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.2 26.7 76.6 72.6-78.2 74-5.5-5.8 72-68.2-70.5-66.7 5.6-5.9z"
  })));
};
export default SvgArrowNext;